module.exports = __webpack_public_path__ + "img/snowboarding.1ab70d7a.svg";